import IntroProductModal from './IntroProductModal';

export default IntroProductModal;
